import home from './src/home.vue'
import GateEquipmentView from './src/GateEquipmentManager/GateEquipmentView.vue' //闸机设备管理列表页
import GateEquipmentInfo from './src/GateEquipmentManager/GateEquipmentInfo.vue' //闸机设备管理详情页
import RopewayEquipmentView from './src/RopewayEquipmentManager/RopewayEquipmentView.vue' //索道设备管理列表页
import RopewayEquipmentInfo from './src/RopewayEquipmentManager/RopewayEquipmentInfo.vue' //索道设备管理详情页
import WeatherEquipmentView from './src/WeatherEquipmentManager/WeatherEquipmentView.vue' //负氧离子监测设备列表页
import WeatherEquipmentInfo from './src/WeatherEquipmentManager/WeatherEquipmentInfo.vue' //负氧离子监测设备详情页

let views = {
    home,
    GateEquipmentView,
    GateEquipmentInfo,
    RopewayEquipmentView,
    RopewayEquipmentInfo,
    WeatherEquipmentView,
    WeatherEquipmentInfo
};

export default views;